import { IS_V2_WRITE_ENABLED } from '@/configs/v2Write';
import { User } from '@/types/user';

/**
 * Откуда берутся логи времени: legacy — прокси к Яндекс Трекеру (v1),
 * v2 — собственный учёт на нашем бэке. Режим задаёт роут страницы
 */
export enum LogsMode {
  legacy = 'legacy',
  v2 = 'v2',
}

/** Куда публикуется черновик или секундомер */
export const LOGS_MODE_TARGET_LABEL: Record<LogsMode, string> = {
  [LogsMode.legacy]: 'В Яндекс Трекер',
  [LogsMode.v2]: 'В наш учёт',
};

/** Id пользователя в системе логов режима: в Трекере — uid Яндекса, у нас — uuid */
export const getLogsUserId = ({ user, mode }: { user: User; mode: LogsMode }): string | null =>
  mode === LogsMode.v2 ? user.id : user.yandexUid;

/** Логи режима только для просмотра: собственный учёт пока бэкап Трекера (см. `IS_V2_WRITE_ENABLED`) */
export const isLogsReadOnly = (mode: LogsMode): boolean =>
  mode === LogsMode.v2 && !IS_V2_WRITE_ENABLED;

/** Куда можно публиковать черновики и секундомеры: в собственный учёт — только когда в него пишем */
export const PUBLISH_TARGETS: LogsMode[] = IS_V2_WRITE_ENABLED
  ? [LogsMode.legacy, LogsMode.v2]
  : [LogsMode.legacy];

/** Ключ localStorage, свой у каждого режима: id пользователей в них разные */
export const getLogsStorageKey = ({ key, mode }: { key: string; mode: LogsMode }): string =>
  mode === LogsMode.v2 ? `${key}_v2` : key;
